<template>
  <div class="content-wrapper">
    <div class="loading" style="left: 0;" v-if="isRender"></div>
    <div class="teacher-banner">
      <swiper :options="bannerOptions" class="swiper-container">
        <swiper-slide class="slide" v-for="banner in banners" :key="banner.image" :style="{backgroundImage: 'url(' + banner.image + ')'}" @click="toActivity(banner)"></swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>
    <div class="teacher-container">
      <div class="teacher-wrapper">
        <div class="avatar-block">
          <img :src="teacher && teacher.logo" />
        </div>
        <div class="info-block">
          <div class="name">{{teacher && teacher.realName}}<span class="vip"></span></div>
          <div class="desc" :class="{'text-show': toggleStatus, 'text-hidden': !toggleStatus}">{{teacher && teacher.introduction}}</div>
        </div>
        <div class="toggle-btn" @click="handleToggleBtnClick" :class="{'rotate': !toggleStatus}"></div>
      </div>
      <div class="app-download" v-if="showAppLink" @click="toApp">
        <div class="app-left">
          <img src="https://upload.chongnengjihua.com/production/htz-download/logo.png">打开app,及时掌握老师解盘
        </div>
        <div class="app-right" @click="reportClickIcon('打开APP')">打开看看</div>
      </div>
      <div ref="liveModule" class="sub-wrapper" v-if="roomInfo">
        <div class="header-title">精彩直播</div>
        <div class="video-info">
          <span>{{roomInfo && roomInfo.roomName}}</span>
          {{roomInfo && roomInfo.introduction}}
        </div>
        <div class="video-content" @click="toLiveRoom">
          <div class="video-player">
            <div class="poster" :style="{'background-image': 'url(' + this.poster + ')'}"></div>
            <div class="play-btn"></div>

            <div v-show="videoActive" class="live-block"></div>
            <div v-show="videoActive" class="read-point"></div>

            <div v-show="!videoActive" class="latest-icon"></div>
            <div v-show="!videoActive" class="latest-text">最新回放</div>
          </div>
          <div class="title-wrapper">
            <div class="title-text">{{periodName}}</div>
            <div class="footer">
              <div>立即观看>></div>
              <div>{{onlineUser}}人 正在看</div>
            </div>
          </div>
        </div>
      </div>
      <div class="sub-wrapper" v-if="courses && courses.length > 0">
        <div class="header-title">热销产品</div>
        <div class="payment-courses-lists">
          <ul class="payment-course">
            <li class="" v-for="(item, index) in courses" :key="index" @click="toCourse(item.courseNo)">
              <img class="course-cover" :src="item.coverImage" alt="cover">
              <p>{{item.name}}</p>
            </li>
          </ul>
        </div>
      </div>
      <div ref="viewpointModule" class="sub-wrapper" style="margin-top:10px;" v-if="showViewpoints">
        <div class="header-title">最新观点</div>
        <div class="labels">
          <span class="label-item" :class="{'active': activeCol === 'all'}" @click="handleSwitchTab('all')">全部</span>
          <span class="label-item" :class="{'active': activeCol === col.code}" @click="handleSwitchTab('colItem',col)" v-for="(col, j) in columnCodes" :key="j">{{col.name}}</span>
        </div>
        <main class="news">
          <article class="news-item" @click="toNews(article)" v-for="(article, index) in articleList" :key="index">
            <div class="news-detail">
              <div class="left-block">
                <header>{{article.title}}</header>
                <div class="text" :class="{'line-5': !article.attribute.listImageUrl, 'min-h': article.attribute.listImageUrl}">
                  {{article.introduction}}
                </div>
                <!-- <div class="tags">
                  <span class="tag" v-for="(tag, i) in article.columnBeans" :key="i">{{tag.name}}</span>
                </div> -->
              </div>
              <div class="right-block" v-if="article.attribute.listImageUrl">
                <img :src="article.attribute.listImageUrl">
              </div>
            </div>
            <footer>
              <span class="author-avatar" :style="{'background-image': 'url(' + (article.author.logo || 'https://upload.chongnengjihua.com/test/2019/6/15/13/13380bd10dccf_1560577898593.png') + ')'}"></span>
              <span class="author-name">{{article.author.realName}}</span>
              <span class="time">{{article.showTime | formatTime('mm-dd HH:MM')}}</span>
              <span class="read">{{article.hitCount | kCount}}阅</span>
              <span class="like">{{(article.basePraisesCount + article.praisesCount) | kCount}}赞</span>
            </footer>
            <div class="footer-line"></div>
          </article>
          <div class="load-tip">
            <span v-if="noMore">没有更多内容</span>
            <span v-if="isloading && !noMore">加载中...</span>
          </div>
        </main>
      </div>
    </div>


  </div>
</template>

<script>
import share from '@/mixins/share-finder.js'
// import {getStorage} from '@/utils/storage.js'
import {getScrollTop, getWindowHeight, getScrollHeight} from '@/utils/scroll.js'
import {formatTime} from '@/filters/index.js'
import url from 'url'
import { mapState } from 'vuex'
import {config} from '@/api'

let query = url.parse(window.location.toString(), true).query
import {
  getLiveRoom,
  getTeacherInfo,
  getArticleList,
  getSubjectColumnList,
  getSubject,
  getOnlineUser,
  getSockIp,
  socketCon,
  getCourses,
  getGoodsNo,
  getActivityList
} from '@/api'

import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'

export default {
  data() {
    const vm = this
    return {
      showAppLink: query.key === 'wechat-common-htz',
      user: null,
      toggleStatus: true,
      teacher: null,
      roomInfo: null,
      onlineMeta: null,
      articleList: [],
      columnCodes: [],
      activeCol: 'all',
      bannerUrl: '',
      isRender: true,
      scrollPosition: 0,
      noMore: false,
      isloading: false,
      originRoomInfo: {},
      columnCodesStr: '',
      courses: [],
      exposedIndexes: new Set(), // 记录已曝光的 banner 索引
      bannerOptions: {
        autoplay: {
          delay: 2000
        },
        on: {
          click: function () {
            const realIndex = this.realIndex;
            // console.log(realIndex)
            vm.toActivity(realIndex)
          },
          slideChange: function () {
            const realIndex = this.realIndex;
            vm.reportExposure(realIndex); // 触发曝光埋点
          },
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          // bulletActiveClass: 'my-bullet-active',
          // bulletClass: 'my-bullet',
          // currentClass : 'my-pagination-current'
        },

      },
      banners: [],
      subjectName: '',
      observers: new Set()
    }
  },
  components: {
    swiper,
    swiperSlide
  },
  computed: {
    ...mapState(['wechatUser', 'serviceConfig']),
    poster () {
      return this.roomInfo && this.roomInfo.periodBean.coverImage || ''
    },
    periodName () {
      return this.roomInfo && this.roomInfo.periodBean.periodName
    },
    videoActive () {
      return this.roomInfo && this.roomInfo.roomVideoBean && this.roomInfo.roomVideoBean.videoActive
    },
    onlineUser () {
      return this.onlineMeta && (this.onlineMeta.app + this.onlineMeta.web)
    },
    showViewpoints() {
      return query.showViewpoints !== 'false';
    },
    teacherNo() {
      return url.parse(window.location.toString(), true).query.teacherNo;
    },
    subjectCode() {
      return url.parse(window.location.toString(), true).query.subjectCode;
    },
    periodNo () {
      return this.roomInfo && this.roomInfo.periodBean && this.roomInfo.periodBean.periodNo
    },
    teacherName() {
      return this.teacher && this.teacher.realName
    },
  },
  filters: {
    formatTime,
    kCount (input) {
      if(input > 1000){
        return (input/1000).toFixed(1) + 'K'
      } else {
        return input
      }
    }
  },
  mixins: [share],
  mounted () {
    let _this = this
    if(this.wechatUser.roomToken) {
      this.$nextTick(() => {
        document.title = '名师解盘'
        window.addEventListener('scroll', () => {
          if(getScrollTop() + getWindowHeight() == getScrollHeight()){
            if (_this.noMore) return
            this.activeCol = this.activeCol || 'all'
            if(_this.columnCodes && _this.columnCodes.length > 0) _this.loadArticles()
          }
        }, true)
      })
      this.init()
    }
    this.$root.$on('userReady', ()=>{
      this.$nextTick(() => {
        document.title = '名师解盘'
        window.addEventListener('scroll', () => {
          if(getScrollTop() + getWindowHeight() == getScrollHeight()){
            if (_this.noMore) return
            this.activeCol = this.activeCol || 'all'
            if(_this.columnCodes && _this.columnCodes.length > 0) _this.loadArticles()
          }
        }, true)
      })
      this.init()
    })
    // this.$nextTick(() => {
    //   window.setWxBtn({jumpLink: ''})
    // })
  },
  beforeUnmount() {
    this.observers.forEach(observer => {
      observer.disconnect()
    })
    this.observers.clear()
  },
  methods: {
    async init () {
      // 获取老师信息
      let teacherNo = url.parse(window.location.toString(), true).query.teacherNo
      let position = url.parse(window.location.toString(), true).query.position
      const {data: teacher} =  await getTeacherInfo({id: teacherNo})
      this.teacher = teacher
      if (position) {
        this.$sa.track('click_lszq', {
          position: position.split('.')[1]
        })
        this.$sa.track('enter_famous_teacher_page', {
          page_title: teacherNo,
          page_source: '九方投资助手',
          teacher_id: teacherNo,
          teacher_name: this.teacherName
        })
      }
      //分享信息
      this.$store.dispatch('set_share_info', {
        title: `向您推荐【${teacher.name}】老师专区`,
        desc: '九方智投首席老师，每交易日解读市场热点，传递投资技巧，点击查看>',
        link: window.location.href,
        imgUrl: teacher.image || '',
        cb: this.onMenuShare
      })
      // 获取直播室信息
      const {appCode: platform, serverId: companyId} = this.serviceConfig
      const {roomToken} = this.wechatUser
      const {data: roomInfo} =  await getLiveRoom({teacherNo, platform, roomToken, companyId})
      this.roomInfo = roomInfo[0]
      this.isRender = false
      // 获取老师活动banner列表
      let requestInfo = {
        activityStatus: 'NOW',
        activityType: 'BANNER',
        applicationCode: platform,
        hiddenStatus: 'SHOWN',
        pageNo: 0,
        pageSize: 3,
        position: position //三个老师不一样的
      }
      let {token} = this.wechatUser
      let resp = await getActivityList(requestInfo, token)
      this.banners = resp.data.list
      if (this.banners.length > 0) {
        this.reportExposure(0)
      }
      // console.log(this.banners, '-----------------')
      // 获取直播室在线人数
      if (this.roomInfo) {
        const {roomNo, periodNo} = this.roomInfo && this.roomInfo.periodBean
        const {data: onlineMeta} =  await getOnlineUser({periodNo, roomNo})
        this.onlineMeta = onlineMeta
        // socket监听
        this.concatSocket(roomNo, periodNo)
      }

      // 获取精品课程信息
      const {appCode, tjAppCode} = this.serviceConfig
      const data = await getCourses({
        appCode: tjAppCode,
        teacherNo
      })
      let forbidCourses = ['224f91924b684a158ae7f9318c39ac38']
      if(data) {
        this.courses = data.filter((course) => {
          return course.payment && (forbidCourses.indexOf(course.courseNo) === -1)
        })
      }
      // 获取专题详情
      let subjectCode = url.parse(window.location.toString(), true).query.subjectCode
      const { imageUrl, name } = await getSubject(appCode, {subjectCode})
      this.bannerUrl = imageUrl
      this.subjectName = name
      // 获取专题信息
      this.columnCodes =  await getSubjectColumnList(appCode, {subjectCode})
      this.loadArticles('all')
      this.initExposureObserver();
    },
    async loadArticles (code) {
      if (this.isloading) return
      this.isloading = true
      if (code) {
        this.activeCol = code
        this.noMore = false
      }
      let columnCodes = ''
      if (this.activeCol === 'all') {
        columnCodes = this.columnCodes.reduce((str, item) => {
          if (!str) {
            return item.code
          } else {
            return str + ',' + item.code
          }
        }, '')
        this.columnCodesStr = columnCodes
      } else {
        columnCodes = this.activeCol
      }
      let {appCode, serverId} = this.serviceConfig
      let {token} = this.wechatUser
      let params = {
        columnCodes: columnCodes,
        appCode,
        showPermission: 9,
        direction: 'DOWN',
        end: new Date().getTime(),
        limit: '10',
        hasTop: 1,
        hasPraises: 1,
        token,
        serverId: serverId
      }
      if (!code && this.articleList && this.articleList.length > 0) params.sortTimestamp = this.articleList[this.articleList.length-1].sortTimestamp
      const {data: articleInfo} =  await getArticleList(params)
      if (articleInfo.data.length === 0) {
        this.noMore = true
      }
      articleInfo.data.forEach((article) => {
        article.columnBeans = article.columnBeans.filter((tag) => {
          return this.columnCodesStr.indexOf(tag.code) > -1
        })
      })

      if (code) {
        this.articleList = articleInfo.data
      } else {
        this.articleList = this.articleList.concat(articleInfo.data)
      }
      this.isloading = false
    },
    toLiveRoom () {
      let appKey = url.parse(window.location.toString(), true).query.key
      const { roomNo = '', roomName = '' } = this.roomInfo || {}
      this.$sa.track('click_broadcast', {
        room_name: roomName,
        room_id: roomNo,
        period_code: this.periodNo,
        teacher_id: this.teacherNo,
        teacher_name: this.teacherName,
      })
      window.location.href = `/wechat-live-common/index.html?key=${appKey}&r=${roomNo}&source=lszq&enter_broadcast_source=teacher_home_page&page_source=teacher_home_page&channel_id=${query.channel_id}`
    },
    toNews (article) {
      // let appKey = url.parse(window.location.toString(), true).query.key
      const { newsId = '', title = '' } = article || {}
      this.$sa.track('click_news_card', {
        news_title: title,
        news_id: newsId,
        subject_id: this.subjectCode,
        subject_title: this.subjectName,
      })
      this.$router.push({
        path: `/launcher-article/${newsId}`,
        query: {
          page_source: 'famous_teacher_page'
        }
      })
      // window.location.href = `/wechat-article-common/index.html?key=${appKey}#/launcher-article/${newsId}`
    },
    checkOriginRoomInfo (r) {
      if (!r.status) return false // 文字直播室不处理
      const {videoActive, status, config: {aliyunEnable, aliyunLubo, aliyunZhibo, baijiayunEnable, baijiayunLubo, baijiayunZhibo, zhanshiEnable, zhanshiZhibo, zhanshiLubo}} = r
      let config = this.originRoomInfo && this.originRoomInfo.config
      if (this.originRoomInfo &&
        this.originRoomInfo.videoActive === videoActive &&
        this.originRoomInfo.status === status &&
        config.aliyunEnable === aliyunEnable &&
        config.aliyunLubo === aliyunLubo &&
        config.aliyunZhibo === aliyunZhibo &&
        config.baijiayunEnable === baijiayunEnable &&
        config.baijiayunLubo === baijiayunLubo &&
        config.baijiayunZhibo === baijiayunZhibo &&
        config.zhanshiEnable === zhanshiEnable &&
        config.zhanshiLubo === zhanshiLubo &&
        config.zhanshiZhibo === zhanshiZhibo) {
        return true
      }
      return false
    },
    async concatSocket (roomNo, periodNo) { // socket链接
      let _this = this
      const {code, ip, port} = await getSockIp('GET_WSS_IP', {})
      if (code === 1) {
        socketCon({
          ip: ip,
          port: port,
          roomNo: roomNo,
          periodNo: periodNo
        },
        function (result) {
          let d = JSON.parse(result)
          let r = d.data
          if (d.cmd === 'roominfo') {
            if (_this.checkOriginRoomInfo(r.roomVideoBean)) return
            _this.originRoomInfo = r.roomVideoBean
            _this.roomInfo = r
          }
        })
      }
    },
    async toCourse(courseNo) {
      const {tjAppCode, pay_url} = this.serviceConfig
      const params = {
        appCode: tjAppCode,
        courseNo
      }
      try {
        const lists = await getGoodsNo(params)
        if(lists) {
          lists.sort((a, b) => (b.price - a.price))
          if (lists[0].goodsNo === 'lycpxl') {
            return location.href = `${pay_url}sales/${lists[0].goodsNo}?linkType=1`
          }
          location.href = `${pay_url}sales/${lists[0].goodsNo}`
        }
      } catch (error) {
        console.log(error)
      }
    },
    toActivity(index) {
      let position = url.parse(window.location.toString(), true).query.position
      if (position) {
        this.$sa.track('click_banner', {
          title: this.banners[index].title,
          position: position.split('.')[1] || ''
        })
        this.$sa.track('click_operation_advertise', {
          click_type: 'click_banner',
          page_title: url.parse(window.location.toString(), true).query.teacherNo,
          advertise_id: this.banners[index].id,
          advertise_name: this.banners[index].title,
          channel_id:query.channel_id||''
        })
      }
      let link = this.banners[index].link
      if (link) {
        // console.log('link-----------', link)
        window.location.href = link
      }
    },
    toApp () {
      // let teacherNo = url.parse(window.location.toString(), true).query.teacherNo
      // window.location.href = `${config.appDownloadUrl}?source=lszq&android_schema=${encodeURIComponent(`ytx://com.rjhy.superstars/teacher?teacherNo=${teacherNo}&source=lszq&teacherName=${this.teacher.realName}`)}`
      window.location.href = config.appDownloadUrl
    },
    reportExposure(index) {
      let teacherNo = url.parse(window.location.toString(), true).query.teacherNo
      if (!this.exposedIndexes.has(index)) {
        this.exposedIndexes.add(index);
        const banner = this.banners[index];
        if (banner) {
          this.$sa.track('diaplay_advertising', {
            title: banner.title,
            activity_type: 'banner',
            page_title: teacherNo
          })
        }
      }
    },
    reportClickIcon(title) {
      this.$sa.track('click_icon_new', {
        title,
        teacher_id: this.teacherNo,
        teacher_name: this.teacherName,
      })
    },
    handleToggleBtnClick() {
      this.toggleStatus = !this.toggleStatus
      this.reportClickIcon('查看更多')
    },
    handleSwitchTab(type, val) {
      let tab_title = type === 'all' ? '全部' : val.name
      this.$sa.track('switch_tab', {
        tab_title,
      })
      if (type === 'all') {
        this.loadArticles('all')
      } else {
        this.loadArticles(val.code)
      }
    },
    initExposureObserver() {
      if (this.$refs.liveModule) {
        this.observeModule( this.$refs.liveModule,  '直播');
      }
      if (this.$refs.viewpointModule) {
        this.observeModule( this.$refs.viewpointModule, '专题' );
      }
    },
    handleExposure(moduleType) {
      const { subjectCode, subjectName, teacherNo } = this
      const { roomNo = '', roomName = '' } = this.roomInfo || {}
      this.$sa.track('display_module', {
        module_type: moduleType,
        ...(moduleType === '专题' && {
          subject_id: subjectCode,
          subject_name: subjectName
        }),
        ...(moduleType === '直播' && {
          room_name: roomName,
          room_id: roomNo
        }),
        teacher_id: teacherNo
      })
    },
    observeModule(target, moduleType) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.intersectionRatio >= 0.1) {
            this.handleExposure(moduleType)
            observer.unobserve(target);
            this.observers.delete(observer)
          }
        });
      }, {
        root: null,
        threshold: 0.1,
        rootMargin: '20px'
      });
      this.observers.add(observer)
      observer.observe(target);
    },
    
  }
}
</script>
<style lang="stylus" scoped>
.app-download
  height 0.7rem
  padding 0 0.3rem
  margin-top 10px
  border-radius 3px
  background-color #ffffff
  display flex
  justify-content space-between
  font-size 0.26rem
  color #333333
  align-items center
  .app-left
    display flex
    img
      width 18px
      height 18px
      margin-right 10px
      position relative
      top 1px
  .app-right
    padding 3px 10px
    border-radius 11px
    background-color #DB423D
    color #ffffff
    font-size 0.24rem

</style>
<style lang="stylus" scoped>
  .swiper-container
    width 100%
    height 2.3rem
    margin-bottom: 0.24rem
    position relative
  .swiper-slide
    width 100%
    height 2.3rem
    background-repeat no-repeat
    background-position center
    background-size cover
  .swiper-pagination
    width: 100%
  .teacher-container
    padding 0 15px
  .content-wrapper
    position: relative;
    bottom: 0;
    top: 0;
    background-size contain !important
    background-color #F7F7F7
    /*padding-top 133px*/
    font-family PingFang SC,Avenir,Helvetica,Arial,sans-serif
    .payment-courses-lists
      padding-bottom .24rem
      padding-top .24rem
      .payment-course
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: space-between;
        p
          width: 3.32rem;
          font-size: 15px
          color: #162641;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          margin-bottom: 0.18rem;
    .course-cover
      width 3.32rem
      height 1.76rem
      margin-bottom .18rem
      border-radius: 4px;
    .teacher-wrapper
      background url('../assets/teacher/teacher-bg.png') left bottom no-repeat
      background-size contain
      min-height: 135px;
      background-color #ffffff
      border-radius 8px
      display flex
      padding 12px
      position relative
      .avatar-block
        flex-basis 70px
        flex-grow 0
        img
          width: 58px;
          height: 58px;
          border-radius: 58px;
          border: 2px solid rgba(0,0,0,.05);
      .info-block
        flex-basis 0
        flex-grow 1
        color: #0B162F;
        .vip
          padding 0 23px
          background url('../assets/teacher/vip.png') center no-repeat
          background-size contain
        .name
          font-size: 19px;
          line-height: 32px;
          font-weight: bold;
          opacity 0.8
        .desc
          font-size: 15px;
          line-height: 21px;
          opacity 0.7
          margin-bottom: 18px;
        .text-show
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
          overflow: hidden;
        .text-hidden
          display:-webkit-box;
          /*-webkit-line-clamp:6;*/
          -webkit-box-orient:vertical;
          overflow:hidden;

      .toggle-btn
        transition .3s
        padding: 6px 24px;
        position: absolute;
        bottom: 5px;
        left: 50%;
        margin-left: -24px;
        background url('../assets/teacher/toggle.png') center no-repeat
        background-size: 25%;
      .rotate
        transform: rotate(180deg);
    .sub-wrapper
      margin-top 40px
      .header-title
        color: #0B162F;
        font-size: 18px;
        line-height: 25px;
        font-weight: bold;
      .video-info
        color: #0B162F;
        line-height 35px
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
        font-size 13px
        margin-left 5px
        color rgba(11, 22, 47, .4)
        span:nth-child(1)
          font-size 15px
          color rgba(11, 22, 47, .8)

      .video-content
        height 285px
        background-color #ffffff
        border-radius 8px
        display: flex;
        flex-direction: column;
        box-shadow: 0px 6px 12px 0px rgba(11, 22, 47, 0.04);
        .video-player
          height: 190px;
          position: relative;
          .poster
            background url('https://upload.chongnengjihua.com/test/2019/2/21/13/bdcaf5354e9dd_1550728279430.png') no-repeat center
            background-size cover
            border-top-left-radius: 8px;
            border-top-right-radius: 8px;
            position absolute
            top 0
            left 0
            right 0
            bottom 0
          .play-btn
            background url('../assets/teacher/play-btn.png') center no-repeat
            background-size contain
            margin: 0 auto;
            color: #ffffff;
            text-align: center;
            position: absolute;
            left: 50%;
            top: 50%;
            padding: 15px;
            margin-left: -15px;
            margin-top: -15px;

          .live-block
            width: 30px;
            height: 13px;
            position absolute
            right 10px
            top 10px
            background url('../assets/teacher/live-icon.png') center no-repeat
            background-size contain
          @keyframes fade
            from {
              opacity 0
            }
            50% {
              opacity 1
            }
            to {
              opacity 0
            }
          .read-point
            width: 6px;
            height: 6px;
            border-radius 6px
            position absolute
            right 46px
            top 14px
            background-color red
            animation fade 2000ms infinite
          .latest-icon
            width 11px
            height 11px
            position absolute
            right 62px
            top 13px
            background url('../assets/teacher/back-icon.png') center no-repeat
            background-size contain
          .latest-text
            height: 14px;
            color #ffffff
            position absolute
            right 10px
            top 10px
            font-size 12px
        .title-wrapper
          height 95px
          font-size: 16px;
          line-height: 22px;
          padding: 10px;
          .title-text
            height 44px
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
          .footer
            display: flex;
            font-size 13px
            justify-content: space-between;
            opacity: 0.5;
            margin-top: 9px;
      .labels
        line-height: 20px;
        padding-bottom: 20px;
        .label-item
          opacity 0.7
          min-width 64px
          display inline-block
          background-color: #FFFFFF;
          border-radius: 5pt 5pt 5pt 0pt;
          border: 1px solid #E0E5F3;
          padding: 1px 6px;
          font-size: 13px;
          box-shadow: 1px 1px 8px 0px rgba(11, 22, 47, 0.05);
          margin-right 8px
          text-align center
        .active
          background: linear-gradient(to right, #FF4E0B, #FF910B);
          color #ffffff
          opacity 1
      .news
        .load-tip
          font-size: 14px;
          text-align: center;
          line-height: 30px;
          height: 30px;
          opacity: .6;
          border-top: 1px solid rgba(102,102,102,0.1);
        .news-item
          // padding-top 8px
          .news-detail
            padding: 8px 0;
            display flex
            .left-block
              flex-basis: 0;
              flex-grow 1
              padding-right 6px
              header
                font-size: 15px;
                line-height: 21px;
                font-weight: bold;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                overflow: hidden;
                margin-bottom: 6px;
                color: #162641;
              .text
                font-size: 13px;
                line-height 18px
                word-break: break-all;
                padding-right: 12px;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                overflow: hidden;
                color: #5D667A;
              .min-h
                // min-height 60px
              .line-5
                display: -webkit-box;
                -webkit-line-clamp: 5;
                -webkit-box-orient: vertical;
                overflow: hidden;
              .tags
                display: flex;
                flex-wrap wrap
                margin-top 10px
                .tag
                  display inline-block
                  font-size: 11px;
                  color: #FF4E0B;
                  border: 1px solid #FF4E0B;
                  margin-right: 10px;
                  padding: 0 3px;
                  border-radius: 2px;
                  height: 20px;
                  line-height: 20px;
                  margin-bottom: 5px;
            .right-block
              flex-basis 126px
              flex-grow 0
              img
                width: 126px;
                height: 84px;
                border-radius: 2px;
          footer
            font-size: 12px;
            display: flex;
            align-items center
            line-height: 30px;
            position relative
            .author-avatar
              display: inline-block;
              background: center no-repeat;
              background-size: contain;
              width: 22px;
              height: 22px;
              border-radius: 22px;
              margin-right: 10px;
            .author-name
              color #707A8D
              font-size 13px
              margin-right: 12px;
            .time
              display inline-block
              width 80px
              color #B4B8C2
              position: relative;
              font-size: 13px;
            .read
              display inline-block
              width 80px
              color #B4B8C2
              position: absolute;
              right: 86px;
              text-align: right;
              font-size: 13px;
            .like
              display inline-block
              width 80px
              color #B4B8C2
              position: absolute;
              right: 0;
              text-align: right;
              font-size: 13px;
            .like-pointer
              background: url('../assets/like.png') center no-repeat;
              background-size: contain;
              padding: 7px;
              margin-right: 3px;
            .like-active
              background-image url('../assets/like-active.png')
          .footer-line
            height: 1px;
            background: #E9EBF0;
            margin: 7px auto;
          &:last-of-type
            .footer-line
              display none



</style>

